import { jsx as _jsx } from "react/jsx-runtime";
import { Popover, PopoverSize, PopoverType, TileList, usePopoverHandlers } from '@as/cotopaxi';
import { determineSelectedSku } from '@as-react/common-utils';
import { Box, ButtonAlpha } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { productActions } from '../../redux/product/actions/ProductActions';
import { makeGetSelectedBundleAlternativeTab } from '../../redux/product/selectors/ProductSelector';
import { ProductBundleAlternativeItem } from './ProductBundleAlternativeItem';
export const ProductBundleAlternative = ({ productSlot, onSubmit, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const dispatch = useDispatch();
    const selectedBundleAlternativeTab = useSelector(makeGetSelectedBundleAlternativeTab());
    const { bundleChildren: alternatives, displayedProduct, slotNumber } = productSlot;
    const [selectedAlternative, setSelectedAlternative] = useState([alternatives[0].productCode]);
    const [formState, setFormState] = useState({ submitCount: 0 });
    const [productState, setProductState] = useState(() => alternatives.reduce((prev, curr) => {
        const currColour = curr.colours[0];
        return Object.assign(Object.assign({}, prev), { [curr.productCode]: {
                productCode: curr.productCode,
                productId: curr.productId,
                colourId: curr.colourId || currColour.colourId,
                skuId: determineSelectedSku(currColour),
            } });
    }, {}));
    const resetSelection = () => {
        setFormState({ submitCount: 0 });
        if (!displayedProduct) {
            setSelectedAlternative([alternatives[0].productCode]);
            return;
        }
        setSelectedAlternative([displayedProduct.productCode]);
    };
    const onPopoverClose = () => {
        dispatch(productActions.bundleSetSelectedAlternativeTab(null));
    };
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers({ close: onPopoverClose });
    useEffect(() => {
        resetSelection();
        if (displayedProduct) {
            setProductState(prevState => (Object.assign(Object.assign({}, prevState), { [displayedProduct.productCode]: Object.assign({}, displayedProduct) })));
        }
    }, [displayedProduct]);
    useEffect(() => {
        if (`bundle-alternatives-slot-${slotNumber}` === selectedBundleAlternativeTab) {
            handlePopoverOpen(null, null, true);
        }
    }, [selectedBundleAlternativeTab]);
    const closePopoverAndDispatchChosenProduct = (product) => {
        if (product.colourId && product.skuId) {
            handlePopoverClose();
            onSubmit(product);
        }
        else {
            setFormState(prev => ({ submitCount: prev.submitCount + 1, error: selectedAlternative[0] }));
        }
    };
    const handlePopoverSubmit = () => closePopoverAndDispatchChosenProduct(productState[selectedAlternative[0]]);
    const handleCloseAndReset = () => {
        handlePopoverClose();
        resetSelection();
    };
    const handleProductChange = (productCode, product, shouldClosePopup = false) => {
        setSelectedAlternative([productCode]);
        if (product) {
            setProductState(prevState => (Object.assign(Object.assign({}, prevState), { [productCode]: product })));
        }
        if (shouldClosePopup) {
            closePopoverAndDispatchChosenProduct(Object.assign({ productCode }, product));
        }
    };
    return (_jsx(Popover, { anchorEl: anchorEl, onClose: handleCloseAndReset, size: PopoverSize.DRAWER_LARGE, title: t('product.bundleDeals.alternative.title_plural'), type: PopoverType.DRAWER, noFooterShadow: true, footerElement: _jsx(Box, { paddingInline: { lg: '4' }, children: _jsx(ButtonAlpha, { fullWidth: true, theme: "branded", text: t('product.bundleDeals.alternative.cta.save'), onClick: handlePopoverSubmit }) }), children: _jsx(TileList, { tileListName: "alternatives", selectable: true, selectableType: "radio", selectedItems: selectedAlternative, onSelectionChange: setSelectedAlternative, boxProps: {
                mobile: { spacing: { marginLeft: 2, marginRight: 2 } },
                tablet: { spacing: { marginLeft: 4, marginRight: 4 } },
            }, children: alternatives.map((alternative, index) => (_jsx(ProductBundleAlternativeItem, { product: alternative, displayed: productState === null || productState === void 0 ? void 0 : productState[alternative.productCode], formState: formState, onProductChange: handleProductChange }, index))) }) }));
};
